import {TAction} from "../../../app/enum";
import {Component, NgZone} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";
import {LogadoService} from "../../../providers/logado-service";
import {CONFIG} from "../../../app/config";
import {DomSanitizer} from "@angular/platform-browser";
import {TextToSpeech} from "@ionic-native/text-to-speech";
import {ProfileService} from "../../../providers/profile-service";

@Component({
    selector: 'page-warning-menu',
    templateUrl: 'warning-menu.html',
    providers: [TextToSpeech, ProfileService]
})
export class WarningMenuPage {

    config: any;
    logado: any;

    etapa: number;

    timeout: number;
    liaindex: number;
    liaspeak: number;
    liahello: boolean;
    gifindex: number;

    constructor(public viewCtrl: ViewController, public navParams: NavParams, public util: Util,
                private tts: TextToSpeech,
                public sanitizer: DomSanitizer, private ngZone: NgZone,
                public logadoService: LogadoService,
                public profileService: ProfileService) {

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Warning', '/warning-menu');

        this.config = CONFIG;
        this.logado = null;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');

        this.liahello = false;
        this.liaindex = 0;
        this.liaspeak = 0;
        this.gifindex = 2;

    }

    ionViewDidEnter() {

        this.util.stylesBarOnoff(false);
        this.talkings('hello');

    }

    talkback() {

        clearTimeout(this.timeout);
        if (this.util.nativeApp()) this.tts.stop();

        if (this.liaindex == 0) return;
        this.talkings('back');

    }

    talknext() {

        if (this.liaindex == this.logado.Warnings.length-1) {
            this.dismiss();
            return;
        }

        clearTimeout(this.timeout);
        if (this.util.nativeApp()) this.tts.stop();

        this.talkings('next');

    }

    talkings(start: null | 'start' | 'back' | 'next' | 'hello') {

        if (start == 'hello') {
            if (this.util.nativeApp()) this.tts.speak({text: 'Olá Caio, eu sou a LIA.', rate: 1.65, locale: 'pt-BR'});
            return;
        }

        let timeout = (start == 'start' ? 0 : 2000);

        this.timeout = setTimeout(() => {

            let index = this.liaindex;
            let speak = this.liaspeak;


            //Comeco do zero
            if (start == null) {
                //index = 0;
                speak++;
            }

            //Comeco do zero
            if (start == 'start') {
                index = 0;
                speak = 1;
            }

            //Assunto Anterior
            if (start == 'back') {
                index--;
                speak = 1;
            }

            //Proximo Assunto
            if (start == 'next' || (start == null && speak-2 >= this.logado.Warnings[index].Array.length)) {
                index++;
                speak = 1;
            }

            let texto = '';
            if (index < this.logado.Warnings.length) texto = (speak == 1 ? this.logado.Warnings[index].Title : this.logado.Warnings[index].Array[speak-2]);

            //TAG remove
            while (texto.indexOf('<b>') >= 0) texto = texto.replace('<b>', '');
            while (texto.indexOf('</b>') >= 0) texto = texto.replace('</b>', '');
            while (texto.indexOf('<br>') >= 0) texto = texto.replace('<br>', '');

            //BR texto
            while (texto.indexOf('Lorean')  >= 0) texto = texto.replace('Lorean',  'Lórean');
            while (texto.indexOf('Payout')  >= 0) texto = texto.replace('Payout',  'Peyaut');
            while (texto.indexOf('Webstor') >= 0) texto = texto.replace('Webstor', 'Uébstor');
            while (texto.indexOf('Hotspot') >= 0) texto = texto.replace('Hotspot', 'Rótspot');

            this.liahello = true;
            this.liaindex = index;
            this.liaspeak = speak;
            this.ngZone.run(() => {});
            if (this.util.nativeApp() && texto) this.tts.speak({text: texto, rate: 1.65, locale: 'pt-BR'});
                //.then(() => console.log('Success'))
                //.catch(erro => console.log(erro));

        }, timeout);

    }

    warningLast() {

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.warning(TAction.acLast, this.logado.Warnings[this.logado.Warnings.length-1].WarningID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.dismiss(),
                    erro => this.util.alertResult(erro)
            );

    }

    dismiss() {

        clearTimeout(this.timeout);
        if (this.util.nativeApp()) this.tts.stop();

        this.logado.Warnings = null;
        this.util.stylesBarOnoff(true);
        this.viewCtrl.dismiss();

    }

}




// WEBPACK FOOTER //
// ./src/pages/sync/warning-menu/warning-menu.ts